import React, {Fragment, useEffect, useRef} from 'react';
import {SpinnerBasic} from "./Spinner-basic";
import {NavMenu} from "./NavMenu";
import {Application} from "./Application";
import {Coverage} from "./Coverage";
import {Premium} from "./Premium";
import {Confirmation} from "./Confirmation";
import {Complete} from "./Complete";
import {Optional} from "./Optional";
import '../custom.css';
import {Screen} from "./Screen";
import {Footer} from "./Footer";
import {CustomerSupport} from "./CustomerSupport";
import {AproposUnavailable} from "./AproposUnavailable";
import {SOAForm} from "./SOAForm/SOAForm";
import {SOAQualification} from "./SOAForm/SOAQualification";
import {ErrorOnPost} from "./ErrorOnPost";
import AlreadyInUse from "./AlreadyInUse";
import {SelfDirected} from "./SelfDirected/SelfDirected";
import {EffectiveDate} from "./EffectiveDate";
import {FormID} from "../FormID";

export function Home(props) {
    const scrollTopRef = useRef(null);

    useEffect(() => {
        scrollTopRef.current.scrollIntoView();
    }, [props.step]);

    const renderBody = () => {
        return (
            <Fragment>
                {props.isSubmitting && <SpinnerBasic/>}
                <main id={"content"} ref={scrollTopRef} className={"print"}>
                    <NavMenu step={props.step}/>

                    <AproposUnavailable step={props.step} loadError={props.loadError}/>
                    
                    <SelfDirected step={props.step}
                                  lastStep={props.lastStep}
                                  onChange={props.onChange}
                                  loadError={props.loadError}/>
                    
                    <Screen step={props.step}
                            lastStep={props.lastStep}
                            onChange={props.onChange}
                            loadError={props.loadError}
                            screen={props.screen}
                            handleScreenChange={props.handleScreenChange}
                            facilities={props.facilities}
                            soaForm={props.soaForm}
                            setScreenItem={props.setScreenItem}
                            isAgent={props.isAgent}/>

                    <Application step={props.step}
                                 lastStep={props.lastStep}
                                 facilities={props.facilities}
                                 onChange={props.onChange}
                                 planChoice={props.planChoice}
                                 setPlanChoice={props.setPlanChoice}
                                 textModel={props.textModel}
                                 member={props.member}
                                 memberAddress={props.memberAddress}
                                 mailingAddress={props.mailingAddress}
                                 handleMemberChange={props.handleMemberChange}
                                 isAgent={props.isAgent} 
                                 handleCoverageChange={props.handleCoverageChange} {...props}/>
                    <EffectiveDate step={props.step}
                                   isAgent={props.isAgent}
                                   textModel={props.textModel}
                                   maPlans={props.maPlans}
                                   maPlanId={props.maPlanId}
                                   effectiveDate={props.effectiveDate}
                                   setEffectiveDate={props.setEffectiveDate}
                                   lastStep={props.lastStep}
                                   onChange={props.onChange}
                    />                    
                    <Coverage step={props.step}
                              lastStep={props.lastStep}
                              onChange={props.onChange}
                              handleCoverageChange={props.handleCoverageChange}
                              medicareCoverage={props.medicareCoverage}/>

                    <Premium step={props.step}
                             lastStep={props.lastStep}
                             onChange={props.onChange}
                             display={props.step === 4}
                             maPlanId={props.maPlanId}
                             maPlans={props.maPlans}
                             effectiveDate={props.effectiveDate}
                             planChoice={props.planChoice}
                             premium={props.premium}
                             handlePremiumChange={props.handlePremiumChange} 
                             resetPremium={props.resetPremium} 
                             premiumPaymentOptions={props.premiumPaymentOptions}/>

                    <Optional step={props.step}
                              lastStep={props.lastStep}
                              onChange={props.onChange}
                              display={props.step === 5}
                              optionalInformation={props.optionalInformation}
                              handleOptionalChange={props.handleOptionalChange} 
                              races={props.races} 
                              ethnicities={props.ethnicities} 
                              handleEthnicityChange={props.handleEthnicityChange} 
                              handleRaceChange={props.handleRaceChange}
                              planChoice={props.planChoice}
                    />

                    <Confirmation step={props.step}
                                  lastStep={props.lastStep}
                                  onChange={props.onChange}
                                  onFormSubmit={props.onFormSubmit}
                                  display={props.step === 6}
                                  confirmation={props.confirmation}
                                  handleAuthorizedRepChange={props.handleAuthorizedRepChange}
                                  handleConfirmationChange={props.handleConfirmationChange}
                                  member={props.member}
                                  authorizedRepresentative={props.authorizedRepresentative}
                                  isAuthRep={props.isAuthRep}
                                  authorizedRepresentativeRelationships={props.authorizedRepresentativeRelationships}
                                  soaForm={props.soaForm}
                                  isAgent={props.isAgent}
                                  handleSalesAgentEnteredChange={props.handleSalesAgentEnteredChange}
                                  handleSalesAgentAssistedChange={props.handleSalesAgentAssistedChange}
                                  enteringSalesAgentId={props.enteringSalesAgentId}
                                  handleSalesAgentIdChange={props.handleSalesAgentIdChange}
                                  handleTelephonicApplicationChange={props.handleTelephonicApplicationChange}
                                  isTelephonicApplication={props.isTelephonicApplication}
                                  salesAgentEntered={props.salesAgentEntered}
                                  handleApplicationFileChange={props.handleApplicationFileChange}
                                  handleAssistingAgentNameChange={props.handleAssistingAgentNameChange}
                                  assistingAgentName={props.assistingAgentName}
                                  handleRelationshipToEnrolleeChange={props.handleRelationshipToEnrolleeChange}
                                  handleRelationshipToEnrolleeNameChange={props.handleRelationshipToEnrolleeNameChange}
                    />

                    {props.isPostError === false &&
                    <Complete step={props.step}
                              lastStep={props.lastStep}
                              onChange={props.onChange}
                              confirmationNumber={props.confirmationNumber}
                              isPostError={props.isPostError}
                              planChoice={props.planChoice}
                    />
                    }

                    {props.isPostError === true && 
                    <ErrorOnPost step={props.step}
                                 lastStep={props.lastStep}
                                 onChange={props.onChange}
                                 confirmationNumber={props.confirmationNumber}
                                 isPostError={props.isPostError}
                                 agentInfo={props.soaForm}
                                 planChoice={props.planChoice}
                    />
                    }
                    <CustomerSupport/>
                    <AlreadyInUse {...props} />
                {props.step > 0 && props.maPlans &&
                    <FormID
                        maPlans={props.maPlans}
                        effectiveDate={props.effectiveDate}
                        maPlanId={props.maPlanId}
                    />
                }
                </main>
                <Footer planChoice={props.planChoice} step={props.step}/>
            </Fragment>
        );
    }

    return (
        <Fragment>
            {props.loading === true
                ? <SpinnerBasic/>
                : renderBody()}
        </Fragment>
    );
}


